import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_license_plate_labels_by_order_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], Shipment?: { Id?: number, LookupCode?: string, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] }, ArchivedShippingLicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], TotalPackagedAmount?: number, OrderLookupCode?: string, MaterialLookupCode?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ManufactureDate?: string, ProjectLookupCode?: string, ExpirationDate?: string, Packaging?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], Shipment?: { Id?: number, LookupCode?: string, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] }, ArchivedShippingLicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], TotalPackagedAmount?: number, OrderLookupCode?: string, MaterialLookupCode?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ManufactureDate?: string, ProjectLookupCode?: string, ExpirationDate?: string, Packaging?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], Shipment?: { Id?: number, LookupCode?: string, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] }, ArchivedShippingLicensePlateContents?: { LotId?: number, PackagedId?: number, Amount?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string } }, Packaged?: { ShortName?: string } }[], TotalPackagedAmount?: number, OrderLookupCode?: string, MaterialLookupCode?: string, LotLookupCode?: string, VendorLotLookupCode?: string, ManufactureDate?: string, ProjectLookupCode?: string, ExpirationDate?: string, Packaging?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
